import * as endpoints from './endpoints';
import * as api from 'config/axios';

export const sendGetAvailEntityDateField = () => {
  return api.sendGet(endpoints.GET_AVAILABLE_ENTITY_DATA_FIELD);
};
